module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-24x24-79ebd709242e763367174de01491501c.png";